// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyState_container__2YQSE","text":"EmptyState_text__2k-FR"};